// API configuration utility
const getApiBaseUrl = () => {
    // In browser context, we need to use localhost, not Docker container names
    // The REACT_APP_API_URL with container names won't work in browser

    if (process.env.NODE_ENV === 'development') {
        // Always use localhost for browser requests in development
        if (typeof window !== 'undefined') {
            // We're in the browser - use localhost and determine port
            const currentPort = window.location.port;

            // If frontend is on 3001, backend is on 3000
            if (currentPort === '3001') {
                return `${window.location.protocol}//${window.location.hostname}:3000`;
            }

            // If frontend is on 3000 (unlikely but possible), backend might be on different port
            // For now, assume backend is on 3000
            return `${window.location.protocol}//${window.location.hostname}:3000`;
        }
    }

    // For server-side rendering or non-browser environments, use relative URLs
    return '';
};

export const API_BASE_URL = getApiBaseUrl();

// Helper function to make API requests
export const apiRequest = async (endpoint, options = {}) => {
    const url = `${API_BASE_URL}/api${endpoint}`;
    //console.log('Making API request to:', url); // Debug logging

    const response = await fetch(url, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

    if (!response.ok) {
        console.error('API request failed:', response.status, response.statusText);
        throw new Error(`API request failed: ${response.status} ${response.statusText}`);
    }

    return response;
};